import { render, staticRenderFns } from "./UserRegistrationSummary.vue?vue&type=template&id=4d1369fe&"
import script from "./UserRegistrationSummary.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports